import Card from "./Card.vue";
import Container from "./Container.vue";
import EditDialog from "./EditDialog.vue";
import ListPage from "./ListPage.vue";
import ChartMap from "./ChartMap.vue";
import DatePicker from "./DatePicker.vue";
import ChildLayout from "./ChildLayout.vue";
import Page from "./Page";
import DistrictPicker from "./DistrictPicker";
import TreeSelect from "./TreeSelect";
import Guid from "./Guid";
import EntityLocation from "./EntityLocation.vue";
import SelectDoor from "./SelectDoor.vue";
import ExportButton from "./ExportButton.vue";

const array = [
    Card,
    Container,
    EditDialog,
    ListPage,
    ChartMap,
    DatePicker,
    ChildLayout,
    Page,
    DistrictPicker,
    EntityLocation,
    TreeSelect,
    SelectDoor,
    ExportButton,
    Guid,
];

const baseComponents = {
    install(vue) {
        for (let i = 0; i < array.length; i++) {
            vue.component(array[i].name, array[i]);
        }
    },
};

export default baseComponents;
